(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function parseEnd(dateStr, timeStr) {
      var d = (dateStr || '').split('-');
      if (d.length !== 3) return null;
      var t = (timeStr || '00:00').split(':');
      var end = new Date(
        parseInt(d[0], 10),
        parseInt(d[1], 10) - 1,
        parseInt(d[2], 10),
        parseInt(t[0], 10) || 0,
        parseInt(t[1], 10) || 0,
        0
      );
      return isNaN(end.getTime()) ? null : end;
    }

    function initTimer(el) {
      if (el.dataset.ctaCdInit) return;
      el.dataset.ctaCdInit = 'true';

      var end = parseEnd(el.dataset.endDate, el.dataset.endTime);
      var days = el.querySelector('[data-days]');
      var hours = el.querySelector('[data-hours]');
      var minutes = el.querySelector('[data-minutes]');
      var seconds = el.querySelector('[data-seconds]');
      var interval;

      function tick() {
        var diff = end ? end.getTime() - Date.now() : 0;
        if (diff < 0) diff = 0;

        var total = Math.floor(diff / 1000);
        days.textContent = pad(Math.floor(total / 86400));
        hours.textContent = pad(Math.floor((total % 86400) / 3600));
        minutes.textContent = pad(Math.floor((total % 3600) / 60));
        seconds.textContent = pad(total % 60);

        if (diff === 0 && interval) clearInterval(interval);
      }

      tick();
      if (end) interval = setInterval(tick, 1000);
    }

    function initAll() {
      document.querySelectorAll('[data-cta-cd-timer]').forEach(initTimer);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-cstm"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.product-card-cstm').forEach(function (section) {
  var heroImages = Array.prototype.slice.call(section.querySelectorAll('[data-pcc-hero-index]'));
  var cards = Array.prototype.slice.call(section.querySelectorAll('[data-pcc-card-index]'));
  var prevBtn = section.querySelector('.pcc-nav__btn--prev');
  var nextBtn = section.querySelector('.pcc-nav__btn--next');
  var total = cards.length;
  var current = 0;

  if (!total) return;

  function goTo(index) {
    current = (index + total) % total;

    heroImages.forEach(function (img) {
      img.classList.toggle('is-active', parseInt(img.getAttribute('data-pcc-hero-index'), 10) === current);
    });

    cards.forEach(function (card) {
      card.classList.toggle('is-active', parseInt(card.getAttribute('data-pcc-card-index'), 10) === current);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goTo(current - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goTo(current + 1);
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
